"use client";

import dynamic from "next/dynamic";

// The root layout mounts a Toaster on every page, which put all of sonner —
// 103 KB, the single largest first-party module in the bundle — on the initial
// download of pages that never raise a toast. Toasts are only ever triggered by
// an interaction, so the component can arrive after the page has painted.
//
// `ssr: false` needs a client component; the root layout is a server component
// and would throw on the same call.
const Toaster = dynamic(
  () => import("./sonner").then((m) => m.Toaster),
  { ssr: false }
);

export default Toaster;
